module.exports = __webpack_public_path__ + "img/327.9de3f758.jpg";